import React, { useEffect, useRef, ReactNode } from 'react';

interface ClickAwayListenerProps {
    onClickAway: () => void;
    children: ReactNode;
}

const ClickAwayListener: React.FC<ClickAwayListenerProps> = ({
    onClickAway,
    children,
}) => {
    const nodeRef = useRef<HTMLDivElement>(null);

    const handleClickAway = () => {
        if (
            nodeRef.current &&
            !nodeRef.current.contains(event.target as Node)
        ) {
            onClickAway();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickAway);
        document.addEventListener('touchstart', handleClickAway);

        return () => {
            document.removeEventListener('mousedown', handleClickAway);
            document.removeEventListener('touchstart', handleClickAway);
        };
    }, []);

    return <div ref={nodeRef}>{children}</div>;
};

export default ClickAwayListener;
